import i18next from 'i18next';
import { authAPI } from './auth';

const API_BASE = '/api/v1/payment';

export interface PaymentConfig {
  enabled: boolean;
  provider: string;
}

export interface CheckoutResponse {
  redirectUri: string;
  orderId: string;
}

export interface SubscriptionStatus {
  active: boolean;
  cancelAtPeriodEnd?: boolean;
  currentPeriodEnd?: string;
}

class PaymentAPI {
  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const accessToken = authAPI.getAccessToken();

    const response = await fetch(`${API_BASE}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        ...options.headers,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || i18next.t('errors.defaultError'));
    }

    return data;
  }

  async getConfig(): Promise<PaymentConfig> {
    const response = await fetch(`${API_BASE}/config`);
    return response.json();
  }

  async createProCheckout(): Promise<CheckoutResponse> {
    return this.request<CheckoutResponse>('/checkout/pro', {
      method: 'POST',
    });
  }

  async createMaxCheckout(): Promise<CheckoutResponse> {
    return this.request<CheckoutResponse>('/checkout/max', {
      method: 'POST',
    });
  }

  async createCreditsCheckout(quantity: number = 1): Promise<CheckoutResponse> {
    return this.request<CheckoutResponse>('/checkout/credits', {
      method: 'POST',
      body: JSON.stringify({ quantity }),
    });
  }

  async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    return this.request<SubscriptionStatus>('/subscription');
  }

  async cancelSubscription(): Promise<{ message: string }> {
    return this.request<{ message: string }>('/subscription/cancel', {
      method: 'POST',
    });
  }
}

export const paymentAPI = new PaymentAPI();
